import Specialty from './Specialty'
import { Model } from '@vuex-orm/core'

export class Orthopedics extends Specialty {
  static entity = 'orthopedics'
  static baseEntity = 'specialties'

  static fields() {
    return {
      ...super.fields()
    }
  }

  static getLabel(log, component) {
    const item = log[component.id]
    if (!item) {
      return ''
    }
    if (component.id === 'orthopedic-diagnosis') {
      const id = item && item.length ? item[0].id || item[0].value : null

      return (
        TraumaDiagnosis.query().whereId(id).first() ||
        OrthopedicDiagnosis.query().whereId(id).first() ||
        {}
      ).label
    } else if (component.id === 'orthopedic-procedures') {
      return item && Array.isArray(item)
        ? item
            .map(i =>
              i.id || i.value
                ? Orthopedics.getProcedureLabel(i.id || i.value)
                : i
            )
            .join(',')
        : ''
    } else {
      return super.getLabel(log, component)
    }
  }

  static getProcedureLabel(procedureId) {
    return (
      TraumaProcedure.query().whereId(procedureId).first() ||
      OrthopedicProcedure.query().whereId(procedureId).first() ||
      {}
    ).label
  }
}

export class TraumaDiagnosis extends Model {
  static entity = 'traumaDiagnosis'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.string(),
      label: this.string(),
      icd10: this.string(),
      regionId: this.attr(null),
      proceduresIds: this.attr([]),
      procedures: this.hasManyBy(TraumaProcedure, 'proceduresIds'),
      region: this.belongsTo(AnatomicRegion, 'regionId')
    }
  }
}

export class TraumaProcedure extends Model {
  static entity = 'traumaProcedure'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.string(),
      label: this.string(),
      icd10: this.string(),
      diagnosticsIds: this.attr([]),
      diagnostics: this.hasManyBy(TraumaDiagnosis, 'diagnosticsIds'),
      regionIds: this.attr([]),
      regions: this.hasManyBy(AnatomicRegion, 'regionIds')
    }
  }
}

export class OrthopedicDiagnosis extends Model {
  static entity = 'orthopedicsDiagnosis'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.string(),
      label: this.string(),
      icd10: this.string(),
      regionId: this.attr(null),
      proceduresIds: this.attr([]),
      procedures: this.hasManyBy(OrthopedicProcedure, 'proceduresIds'),
      region: this.belongsTo(AnatomicRegion, 'regionId')
    }
  }
}

export class OrthopedicProcedure extends Model {
  static entity = 'orthopedicsProcedures'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.string(),
      label: this.string(),
      icd10: this.string(),
      diagnosticsIds: this.attr([]),
      diagnostics: this.hasManyBy(OrthopedicDiagnosis, 'diagnosticsIds'),
      regionIds: this.attr([]),
      regions: this.hasManyBy(AnatomicRegion, 'regionIds')
    }
  }
}

export class AnatomicRegion extends Model {
  static entity = 'anatomicRegion'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.string(),
      label: this.string(),
      traumaDiagnosisIds: this.attr([]),
      orthopedicsDiagnosisIds: this.attr([]),
      traumaDiagnosis: this.hasManyBy(TraumaDiagnosis, 'traumaDiagnosisIds'),
      orthopedicsDiagnosis: this.hasManyBy(
        OrthopedicDiagnosis,
        'orthopedicsDiagnosisIds'
      ),
      traumaProcedureIds: this.attr([]),
      orthopedicsProcedureIds: this.attr([]),
      traumaProcedures: this.hasManyBy(TraumaDiagnosis, 'traumaProcedureIds'),
      orthopedicsProcedures: this.hasManyBy(
        OrthopedicProcedure,
        'orthopedicsProcedureIds'
      )
    }
  }
}
